import React, { createContext, useState } from 'react';

export const FileUrlsContext = createContext({
	fileUrls: '',
	setFileUrls: () => {},
});

export function FileUrlsProvider({ children }) {
	const [fileUrls, setFileUrls] = useState('');
	return (
		<FileUrlsContext.Provider value={{ fileUrls, setFileUrls }}>
			{children}
		</FileUrlsContext.Provider>
	);
}
